// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, DispatchCompleteSignIn } from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { xGoogleAnalyticsState } from "@werner/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@werner/App/GoogleAnalyticsConnector/Utilities/DataLayer";

const _GaDispatchCompleteSignIn: typeof DispatchCompleteSignIn = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    if (state.xGoogleAnalytics.loginEvent && props.authenticatedSession) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }
        const session = getSession(state);
        const affiliation = getBillToState(state, session.billToId).value?.companyName || props.parameter.userName;

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.loginEventName,
            affiliation,
        };

        dataLayer.push(googleAnalyticsData);
    }
};

addToChainAfter(chain, DispatchCompleteSignIn, _GaDispatchCompleteSignIn);
